import Cookies from "js-cookie";
import config from "@/config";

import { forEach, hasOneOf } from "@/libs/tools";

import { Notification } from "element-ui";

import "element-ui/lib/theme-chalk/index.css";

var CryptoJS = require("crypto-js");

export const TOKEN_KEY = "token";
export const REDIRECTURL_KEY = "reurl";
export const SKIN_KEY = "skin";

export const setToken = token => {
  Cookies.set(TOKEN_KEY, token, { expires: config.cookieExpires || 1 });
};

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY);
  if (token) return token;
  else return false;
};

export const setRedirectUrl = path => {
  Cookies.set(REDIRECTURL_KEY, path, { expires: config.cookieExpires || 1 });
};

export const getRedirectUrl = () => {

  const path = Cookies.get(REDIRECTURL_KEY);
  if(path==undefined){
    return false
  } else if(path.indexOf('landing')>-1){
    return false
  }else if(path.indexOf('mnuac')>-1){
    return false
  }
  else if(path.indexOf('login')>-1){
    return false
  }
  else if(path.indexOf('401')>-1){
    return false
  }
  else if (path) return path;
  else return false;
};

export const offlineCount = () => {
  let _obj = localStorage.getItem("off_files");
  let rv = 0;
  if (_obj) {
    rv = JSON.parse(_obj).length;
  } else {
    rv = 0;
  }

  return rv;
};

export const setSkin = skin => {
  Cookies.set(SKIN_KEY, skin, { expires: config.cookieExpires || 1 });
};

export const getSkin = () => {
  const token = Cookies.get(SKIN_KEY);
  if (token) {
    if (token == true || token == "true") return true;
    else return false;
  } else return false;
};

export const localSave = (key, value) => {
  localStorage.setItem(key, value);
};

export const localRead = key => {
  return localStorage.getItem(key) || "";
};

export const getConfigValueByKey = (config, key, rv) => {
  if (config.filter(x => x.key == key).length == 0) return rv;
  else return config.filter(x => x.key == key)[0].value;
};

export const hasChild = item => {
  return item.children && item.children.length !== 0;
};

// const showThisMenuEle = (item, access) => {
//   if (item.meta && item.meta.access && item.meta.access.length) {
//     if (hasOneOf(item.meta.access, access)) return true
//     else return true
//     //else return false
//   } else return true
// }

export const findRouteNameByPath = (routes, path) => {
  let findName = "";
  //console.log('findRouteNameByPath',path);
  
  routes.forEach(rt => {


    if (rt.path == path) {
      findName = rt;
    }
    else {
      rt.children.forEach(sbrt => {
        // if(sbrt.path.indexOf(':ot')>-1)
        // {
        //   sbrt.path = sbrt.path.replace(':ot', sbrt.meta.ot);
        //   sbrt.params={ot:sbrt.meta.ot};
        // }else
        //
        if (sbrt.path.split("/").length > 3 && path.split("/").length > 3) {
          

          let sbrtarr = sbrt.path.split("/");
          let ptarr = path.split("/");
          if (sbrtarr[1] == ptarr[1] && sbrtarr[2] == ptarr[2]) {


            findName = sbrt;
            let rawParams = "{";
            for (let i = 0; i < sbrtarr.length; i++) {
              if (i > 2) {
                
                rawParams +=
                  '"' +
                  sbrtarr[i].replace(":", "") +
                  '"' +
                  ":" +
                  '"' +
                  ptarr[i] +
                  '"';
                if (i + 1 != sbrtarr.length) rawParams += ",";
              }
            }
            rawParams += "}";
            findName.params = JSON.parse(rawParams);
          }
        }

        if (sbrt.path == path) findName = sbrt;
      });
    }
  });
  return findName;
};

export const createRoute = (data, access) => {
  if (data.meta.access.length == 0 || hasOneOf(data.meta.access, access)) {
    // console.log(data.name, data.params)
    let _route = {
      name: data.name,
      path: data.path,
      params: data.params,
      meta: {
        login: data.meta.login,
        ot: data.meta.ot,
        access: data.meta.access
      },
      component: () => import("@/views/" + data.component),
      children: []
    };

    if (data.children != null && data.children.length > 0) {
      data.children.forEach(subMenu => {
        let sub = createRoute(subMenu, access);
        if (sub != null) {
          _route.children.push(sub);
        }
      });
    }
    return _route;
  } else return null;
};
export const getMenuByRouter = (list, access) => {
  let res = [];
  forEach(list, item => {
    if (
      item.meta != undefined ||
      (item.meta != undefined && !item.meta.hideInMenu)
    ) {
      let obj = {
        icon: (item.meta && item.meta.icon) || "",
        name: item.name,
        meta: item.meta
      };
      //if ((hasChild(item) || (item.meta && item.meta.showAlways)) && showThisMenuEle(item, access)) {
      if (hasChild(item)) {
        obj.children = getMenuByRouter(item.children, access);
      }
      //     if (item.meta && item.meta.href) obj.href = item.meta.href
      //     if (showThisMenuEle(item, access)) res.push(obj)
      res.push(obj);
    }
  });
  return res;
};

export const manageMainLayoutConfig = (toPath, store, clear, fromLogin) => {
  //console.log('manageMainLayoutConfig', clear);
  let _obj = store.state.app.mainLayoutConfig;
  if (clear != undefined && clear) {
    if (
      store.state.app.activeGroup.publicPage != undefined &&
      store.state.app.activeGroup.publicPage.has
    ) {
      if (toPath.name == "landingPage") {
        _obj.header = 0;
        _obj.aside = false;
        _obj.footer = false;
      }
      // else if(toPath.name =='ipomLandings'){
      //   console.log('step 0.1');
      //   _obj.header=0;
      //   _obj.aside= true;
      //   _obj.footer=false;
      // }
      else {
        if (toPath.name == "login" || fromLogin) {
          _obj.header = -1;
          _obj.aside = false;
          _obj.footer = true;
        } else {
          _obj.header = 0;
          _obj.aside = false;
          _obj.footer = false;
        }
      }
    } else {
      _obj.header = -1;
      _obj.aside = false;
      _obj.footer = true;
    }
  } else {
    //console.log('step 1.0');
    if (store.state.user.userId != "") {
      if (toPath.name != "") {
        //console.log('step 1');
        if (hasOneOf([toPath.name], config.lmsPages)) {
          _obj.header = 2;
          _obj.aside = false;
          _obj.footer = false;
        } else if (toPath.name == "home") {
          _obj.header = -1;
          _obj.aside = false;
          _obj.footer = false;
        }
        // else if(toPath.name =='ipomLandings'){
        //   console.log('nevtersen murtluu ipom search hesegrvv orson eseh ?');
        //   _obj.aside= true;
        // }
        else {
          _obj.header = 1;
          _obj.aside = true;
          _obj.footer = false;
        }
      } else {
        _obj.header = 0;
        _obj.aside = false;
        _obj.footer = false;
      }
    }
    // else if(toPath.name =='landingIpom'){
    //   console.log('end orj irj bnuuuuuuuuuuuuuuuuuuuuuu');
    //   _obj.footer= false;
    //   _obj.header=0;
    //   _obj.aside= false;
    // }
    else {
      _obj.footer = false;
      _obj.header = 0;
      _obj.aside = false;
    }
  }
  store.dispatch("handleMainLayoutConfig", _obj);
};

export const dynamicDispatcher = res => {
  var Pass = CryptoJS.enc.Utf8.parse(res.data.substring(0, 22));
  var encryptData = res.data.substring(22, res.data.length);

  try {
    var iv = CryptoJS.enc.Hex.parse("e84ad660c4721ae0e84ad660c4721ae0");
    var Salt = CryptoJS.enc.Utf8.parse("u2m9d2dfds1xS!2");
    var key128Bits1000Iterations = CryptoJS.PBKDF2(
      Pass.toString(CryptoJS.enc.Utf8),
      Salt,
      { keySize: 128 / 32, iterations: 1000 }
    );
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(encryptData)
    });

    var decrypted = CryptoJS.AES.decrypt(
      cipherParams,
      key128Bits1000Iterations,
      { mode: CryptoJS.mode.CBC, iv: iv, padding: CryptoJS.pad.Pkcs7 }
    );
    let data = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
    //console.log('data code================ ', data.code);
    if (data.code !== 200) {
      if (data.code === 401) {
        Cookies.remove(TOKEN_KEY);
        window.location.href = "/";
        //window.location.href = '/#/login'
        // Notice.error({desc:'Нэвтрэх шаардлагатай'})
      } else if (data.code === 204) {
        Notification.info({
          message: data.msg,
          title: "Мэдэгдэл",
          duration: 6000,
          type: "error",
          position: "top-right",
          offset: 50
        });
      } else if (data.code === 201) {
        Notification.info({
          message: data.msg,
          title: "Мэдэгдэл",
          duration: 3000,
          type: "info",
          position: "top-right",
          offset: 50
        });
      } else if (data.code === 202) {
        Notification.info({
          message: data.msg,
          title: "Мэдэгдэл",
          duration: 6000,
          type: "warning",
          position: "top-right",
          offset: 50
        });
      } else if (data.code === 203) {
        Notification.info({
          message: data.msg,
          title: "Мэдэгдэл",
          duration: 30000,
          type: "error",
          position: "top-right",
          offset: 50
        });
      } else if (data.code === 500) {
        Notification.info({
          message: data.msg,
          title: "Мэдэгдэл",
          duration: 30000,
          type: "error",
          position: "top-right",
          offset: 50
        });
      } else if (data.code === 503) {
        Notification.info({
          message: data.msg,
          title: "Мэдэгдэл",
          duration: 30000,
          type: "error",
          position: "top-right",
          offset: 50
        });
      }
      //   if (data.msg) Notice.error({
      //     title: 'Алдаа',
      //     desc: data.msg,
      //     duration:20
      // });

      // this.hideLoading();
      return false;
    } else return data;
  } catch (ex) {
    Notification.info({
      message: ex,
      title: "Мэдэгдэл",
      duration: 10000,
      type: "warning",
      position: "top-right",
      offset: 50
    });

    return false;
  }
};

/**
 * @param {*} access
 * @param {*} route
 */
const hasAccess = (access, route) => {
  // console.log("", route);
  if (
    route.meta &&
    route.meta.access != undefined &&
    route.meta.access.length != 0 &&
    route.meta.access
  ) {
    return hasOneOf(access, route.meta.access);
  } else return true;
};

/**
 *
 * @param {*} name
 * @param {*} access
 * @param {*} routes
 * @description
 */
export const canTurnTo = (name, access, routes) => {
  const routePermissionJudge = list => {
    return list.some(item => {
      if (item.children && item.children.length) {
        return routePermissionJudge(item.children);
      } else if (item.name === name) {
        return hasAccess(access, item);
      }
    });
  };

  return routePermissionJudge(routes);
};
// export const canTurnTo = () => {
//     return true;
//   }

export const getObjectTitleById = (objectTypes, objectTypeId) => {
  let ot = objectTypes.filter(x => x.id == objectTypeId);
  return ot[0].title;
};

export const romanize = num => {
  var lookup = {
      M: 1000,
      CM: 900,
      D: 500,
      CD: 400,
      C: 100,
      XC: 90,
      L: 50,
      XL: 40,
      X: 10,
      IX: 9,
      V: 5,
      IV: 4,
      I: 1
    },
    roman = "",
    i;

  for (i in lookup) {
    while (num >= lookup[i]) {
      roman += i;
      num -= lookup[i];
    }
  }
  return roman;
};

export const alphabetize = dividend => {
  dividend = dividend + 1;
  var columnName = "";
  var modulo;

  while (dividend > 0) {
    modulo = (dividend - 1) % 26;
    columnName = String.fromCharCode(65 + modulo) + columnName;
    dividend = parseInt((dividend - modulo) / 26, 10);
  }

  return columnName;

  // if(i>25){
  //   let ii=i-25;
  //   return 'A'+(ii >= 26 ? idOf((ii / 26 >> 0) - 1) : '') + 'abcdefghijklmnopqrstuvwxyz'[ii % 26 >> 0].toUpperCase();
  // }else{
  //   return (i >= 26 ? idOf((i / 26 >> 0) - 1) : '') + 'abcdefghijklmnopqrstuvwxyz'[i % 26 >> 0].toUpperCase();
  // }
};
